// Message for a failed packing-session request: the localized copy for the backend's
// `code` wins over its raw English `error` (which carries ids), which wins over `fallback`.
export const resolvePackingErrorMessage = (err, messages, fallback) => {
  const data = err?.response?.data
  return messages[data?.code] || data?.error || fallback
}
